module.exports = __webpack_public_path__ + "img/05.3e2ccb51.png";